import * as Objdict from "objdict"

import ranges from "@frog/source/data/skills/parts/ranges.js"
import targets from "@frog/source/data/skills/parts/targets.js"
import flavors from "@frog/source/data/skills/parts/flavors.js"
import elements from "@frog/source/data/elements.js"

// some old skills: https://gist.github.com/ehgoodenough/e329ceb141294e6b0f1fd375acf973fe

import skills1 from "@frog/source/data/skills/effects/inflict-damage.js"
import skills2 from "@frog/source/data/skills/effects/repositioning.js"
import skills3 from "@frog/source/data/skills/effects/escape.js"
import skills4 from "@frog/source/data/skills/effects/farming.js"
let skills = Objdict.merge({}, skills1, skills2, skills3, skills4)

import Unit from "@frog/source/models/Unit.js"
import Geometry from "@frog/source/utility/Geometry.js"
import("@frog/source/models/Stage.js").then((module) => {
    const Stage = module.default
    Object.values(skills).forEach((skill) => {
        if(skill.demonstration != undefined) {
            const stage = Stage.load({"stage": skill.demonstration.stage})
            const actions = skill.demonstration.actions.map((protoaction) => {
                const actionmap = Unit.calculateActions(protoaction.unitKey, stage)
                const actions = Stage.flattenActionMap(actionmap)
                const action = actions.find((action) => {
                    return Geometry.equals2d(action.positions[1], protoaction.previousPosition)
                        && Geometry.equals2d(action.positions[0], protoaction.nextPosition)
                        && action.performerKey == protoaction.unitKey
                        && action.skillKey == protoaction.skillKey
                        && action.type == protoaction.type
                })

                return action
            })

            let steps = []
            actions.forEach((action) => {
                if(action == undefined) return
                steps = steps.concat(action.steps)
            })

            skill.demonstration.sequence = {
                "isLooping": true,
                // "alphastage": stage,
                "steps": steps
            }
        }
    })
})

// SKILL SCHEMA v4 MUST SUPPORT:
// deconstructed parameter signature for target, performer and action.
// only being passed performerKey and action, not the explicit target keys.
// being able to be run on tile without a unit to target, returning nothing.
// must declare key in results. cannot rely on old target/performer shorcuts.
// must declare key relative to stage schema, so deltastage.units[key] = deltaunit
// can return a single delta or an array of deltas for separating into animations
// must handle reactions like traps or death?

const xskills = {}
export default xskills
xskills.get = function(skillKey) {
    if(skillKey == undefined) {
        return undefined
    }
    if(skills[skillKey] != undefined) {
        return skills[skillKey]
    }

    let skill = {}
    skillKey.split(" ").forEach((skillPart) => {
        if(skills[skillPart] != undefined) {
            skill = Objdict.merge(skill, skills[skillPart])
        }
        if(skillPart.includes(":")) {
            const key = skillPart.split(":")[0]
            let value = skillPart.split(":")[1]
            if(isNaN(value) == false) value = parseFloat(value)
            if(value == "true") value = true
            if(value == "false") value = false

            if(key == "range"
            && ranges[value] != undefined) {
                return skill = Objdict.merge(skill, {"range": ranges[value]})
            }

            // if(key == "element"
            // && elements[value] != undefined) {
            //     return skill = Objdict.merge(skill, elements[value])
            // }

            if(key == "target"
            && targets[value] != undefined) {
                return skill = Objdict.merge(skill, {"canTarget": targets[value]})
            }

            if(key == "flavor"
            && flavors[value] != undefined) {
                return skill = Objdict.merge(skill, flavors[value])
            }

            return skill = Objdict.merge(skill, {[key]: value})
        }
        // if(skillPart.endsWith("-potent")) {
        //     skill = Objdict.merge(skill, potencies[skillPart] || {})
        // }
        // if(skillPart == "inflictsFlinch") { // ONLY WORKS WITH STRIKE RIGHT NOW
        //     skill = Objdict.merge(skill, {"inflictsFlinch": true})
        // }
        // if(skillPart.endsWith("-variant")) {
        //     const string = "-variant"
        //     skill = Objdict.merge(skill, {
        //         "variant": skillPart.substring(0, skillPart.length - string.length)
        //     })
        // }
        // if(skillPart == "generic-animation") {
        //     skill = Objdict.merge(skill, {
        //         "animation": "generic"
        //     })
        // }
    })
    skills[skillKey] = skill
    return skill
}
